/**
 * Source unique de la copie de consentement RGPD du formulaire.
 * Le texte AFFICHÉ (StepInfos) et le texte STOCKÉ (submitLead → optin_text /
 * marketing_optin_text) proviennent d'ici : c'est ce qui garantit l'intégrité
 * de la preuve de consentement. Bumper CONSENT_VERSION à chaque changement de copie.
 */

export const CONSENT_VERSION = "2026-07-13";

export const CONSENT_TRAITEMENT_TEXT =
  "J'accepte que Komilfo et le magasin partenaire de mon secteur utilisent ces informations pour traiter ma demande de devis.";

export const CONSENT_MARKETING_TEXT =
  "J'accepte d'être recontacté(e) par Komilfo et son réseau, par email, SMS et téléphone, dans le cadre de propositions commerciales liées à mon projet.";

export const MARKETING_CHANNELS = ["email", "sms", "tel"] as const;

// Copie de soutien UI (non stockée) : cadrage bénéfice + réassurance, pour
// maximiser l'acceptation de la case facultative sans dark pattern.
export const CONSENT_MARKETING_BENEFIT =
  "Offres, nouveautés et conseils pour votre projet.";
export const CONSENT_MARKETING_REASSURANCE =
  "Vous pouvez vous désinscrire à tout moment.";

export const LEGAL_MENTION =
  "Les informations de ce formulaire font l'objet d'un traitement après recueil de votre consentement destiné à : KOMILFO SAS. Pour la finalité suivante : gestion de la relation commerciale et du service après-vente. " +
  "Vous bénéficiez d'un droit d'accès, de rectification, de portabilité, d'effacement de celles-ci ou une limitation du traitement. Vous pouvez vous opposer au traitement des données vous concernant et disposez du droit de retirer votre consentement à tout moment en vous adressant à : KOMILFO SAS, 18 Rue du Bourg Nouveau, 35000 RENNES, email : rgpd@komilfo.fr. " +
  "Vous avez la possibilité d'introduire une réclamation auprès d'une autorité de contrôle.";

export const LEGAL_MENTION_URL =
  "https://www.komilfo.fr/politique-protection-donnees-confidentialite";
